import React, { useState, useEffect } from 'react';
import { Box, Grid, Paper, Typography, Tooltip, Dialog, DialogContent, IconButton } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { useStyles } from './styles';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import TableChartIcon from '@mui/icons-material/TableChart';
import CloseIcon from '@mui/icons-material/Close';
import FolderIcon from '@mui/icons-material/Folder';
import ImageIcon from '@mui/icons-material/Image';
import Folder from '../../../../Assets/folderblue.png'

const ITEMS_PER_PAGE = 20;
const FilesContainer: React.FunctionComponent<any> = ({ cardData }) => {
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedData, setPaginatedData] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  console.log(paginatedData, 'cardDatassssss');

  useEffect(() => {
    if (cardData?.length) {
      const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
      const endIndex = startIndex + ITEMS_PER_PAGE;
      setPaginatedData(cardData.slice(startIndex, endIndex));
      setTotalPages(Math.ceil(cardData.length / ITEMS_PER_PAGE));
    } else {
      setPaginatedData([]);
      setTotalPages(1);
    }
  }, [cardData, currentPage]);
  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  const handlePreview = (url: string) => {
    setPreviewUrl(url);
  };

  const handleClosePreview = () => {
    setPreviewUrl(null);
  };

  const renderPreview = (item: any) => {
    console.log('File Type:', item.fileType);

    if (item.fileType?.toLowerCase() === 'pdf') {
      return (
        <Box sx={{ width: '100%', height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', borderRadius: 2, mb: 1.5 }}>
          <PictureAsPdfIcon sx={{ fontSize: 60, color: '#e53935' }} />
        </Box>
      );
    }
    if (item.fileType?.toLowerCase() === 'csv') {
      return (
        <Box sx={{ width: '100%', height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', borderRadius: 2, mb: 1.5 }}>
          <TableChartIcon sx={{ fontSize: 60, color: '#43a047' }} />
        </Box>
      );
    }
    if (item.fileType?.toLowerCase().includes('doc')) {
      return (
        <Box sx={{ width: '100%', height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', borderRadius: 2, mb: 1.5 }}>
          <DescriptionIcon sx={{ fontSize: 60, color: '#1976d2' }} />
        </Box>
      );
    }
    if (item.fileType?.toLowerCase() === 'png') {
      return (
        <Box sx={{ width: '100%', height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', borderRadius: 2, mb: 1.5 }}>
          <ImageIcon sx={{ fontSize: 60, color: '#ff9800' }} />
        </Box>
      );
    }

    return (
      <Box sx={{ width: '100%', height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', borderRadius: 2, mb: 1.5 }}>
        <InsertDriveFileIcon sx={{ fontSize: 60, color: '#757575' }} />
      </Box>
    );
  };


  return (
    <div className={classes.networkCardContainer}>
      <Box width="100%">
        <Paper className={classes.cardHolder}>
          <Grid container spacing={1}>
            {paginatedData.length > 0 ? (
              paginatedData.map((item) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                  <Paper
                    elevation={2}
                    sx={{
                      borderRadius: 3,
                      padding: 2,
                      backgroundColor: "#F6F8FB",
                      border: "none",
                      boxShadow: "none",
                      cursor: 'pointer'
                    }}
                    onClick={() => item.publicUrl && handlePreview(item.publicUrl)} // Open preview on card click
                  >
                    <Box display="flex" alignItems="center" mb={0.5}>
                      <Typography fontWeight={500} color={"#373A45"} fontSize={14}>{item.title}</Typography>
                    </Box>
                    <Box display="flex" alignItems="center" mb={1}>
                      <Typography fontWeight={400} color={"#373A45"} fontSize={14}>Last Updated on:{item?.Lastupdated}</Typography>
                    </Box>
                    {renderPreview(item)}
                    <Box display="flex" alignItems="center" gap={2} mt={1}>
                      <Box display="flex" alignItems="center">
                        <img
                          src={item.avatarUrl}
                          alt={item.userName}
                          style={{ width: 30, height: 30, borderRadius: '50%', marginRight: 8 }}
                        />
                        <Typography fontWeight={500} color={"#373A45"} fontSize={14}>{item.userName}</Typography>
                      </Box>
                    </Box>
                  </Paper>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center" height={300}>
               <img
                 src={Folder}
                 alt="No files"
                 style={{ width: 100, height: 100, objectFit: 'contain' }}
               />
               <Typography fontWeight={500} color="#757575" fontSize={18} ml={2}>
            Oops! This folder is empty.
               </Typography>
             </Box>
              </Grid>
            )}
          </Grid>
          <Box
            display="flex"
            justifyContent="center"
            sx={{
              mt: 'auto',
              pt: 2,
              backgroundColor: 'white',
              position: 'sticky',
              bottom: 0,
              zIndex: 1,
            }}
          >
            {cardData.length > ITEMS_PER_PAGE && (
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                variant="outlined"
                shape="rounded"
                siblingCount={2}
                boundaryCount={1}
                sx={{
                  '& .MuiPaginationItem-root': {
                    borderRadius: '8px',
                    fontWeight: 400,
                    color: '#000',
                    border: '1px solid #E0E0E0',
                    '&:hover': {
                      backgroundColor: '#F5F5F5',
                    },
                  },
                  '& .MuiPaginationItem-page.Mui-selected': {
                    backgroundColor: '#123A6F',
                    color: '#fff',
                    fontWeight: 500,
                    '&:hover': {
                      backgroundColor: '#123A6F',
                    },
                  },
                  '& .MuiPaginationItem-ellipsis': {
                    color: '#000',
                  },
                  '& .MuiPaginationItem-previousNext': {
                    fontWeight: 400,
                    color: '#000',
                  },
                  '& .MuiPaginationItem-previousNext.Mui-disabled': {
                    color: '#C0C0C0',
                  },
                }}
                showFirstButton={false}
                showLastButton={false}
              />
            )}
          </Box>
        </Paper>
      </Box>
      <Dialog open={!!previewUrl} onClose={handleClosePreview} maxWidth="md" fullWidth>
        <DialogContent>
          <Box display="flex" justifyContent="flex-end">
            <IconButton onClick={handleClosePreview}>
              <CloseIcon />
            </IconButton>
          </Box>
          <iframe
            src={previewUrl || ''}
            title="File Preview"
            style={{ width: '100%', height: '500px', border: 'none' }}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default FilesContainer;
